import { minutesToTimeSpan } from '@/shared/utils/adminpulse';
import angular from 'angular';
//This filter gets a number of minutes and formats it to 'hh:mm' format.
angular.module('commonServices').filter('time', function() {
  return function(time) {
    if (isNaN(time)) return '';
    return minutesToTimeSpan(time);
  };
});
